module.exports = __webpack_public_path__ + "img/price-3.57857bad.png";